export default __webpack_public_path__ + "static/media/overlay-spinner.319dac11.png";